import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiData,
  SellYourArtClickBiEvent,
  BiContextProvidedValue,
  EditSaleBiEvent,
} from '@wix/da-bi/pkg/events';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { useSellActionLogic } from './useSellActionLogic';

/** returns dropdown action for context menus where a deviation might be sold
 *  or the sale edited */
export function useSaleActions(
  deviation: PapiDeviation
): DropdownOption | null {
  const { t } = useTranslation();
  const sellState = useSellActionLogic(deviation);

  // Return null for unsellable states
  if (sellState.isUnsellable || sellState.isSold) {
    return null;
  }

  // Handle edit cases (on sale, pending, or PCP)
  if (sellState.isOnSale || sellState.isPending || sellState.isPcp) {
    return {
      label: t('studio.table.actions.sell.edit'),
      onClick: sellState.isPcp
        ? sellState.callbacks.onEditPcpSaleClick
        : sellState.callbacks.onEditAdoptableSaleClick,
      biData: BiData<EditSaleBiEvent>({
        evid: 354,
        deviationid: deviation.deviationId,
        sectionname: BiContextProvidedValue,
      }),
    };
  }

  // Default sell action
  return {
    label: t('studio.table.actions.sell'),
    onClick: sellState.callbacks.onSellClick,
    biData: BiData<SellYourArtClickBiEvent>({
      evid: 353,
      deviationid: deviation.deviationId,
      sectionname: BiContextProvidedValue,
    }),
  };
}
